import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromSpaceTemplate from './space-template.reducer';

export const selectSpaceTemplateState = createFeatureSelector<fromSpaceTemplate.SpaceTemplateState>(
  fromSpaceTemplate.spaceTemplateFeatureKey
);

export const selectSpaceTemplates = createSelector(
  selectSpaceTemplateState,
  spaceTemplateState => spaceTemplateState.listItems
);

export const selectSpaceTemplatesLoading = createSelector(
  selectSpaceTemplateState,
  spaceTemplateState => spaceTemplateState.listItemsLoading
);

export const selectTemplateUpdate = createSelector(
  selectSpaceTemplateState,
  spaceTemplateState => spaceTemplateState.entityUpdateOngoing
);

export const selectTemplateDeleteOngoing = createSelector(
  selectSpaceTemplateState,
  spaceTemplateState => spaceTemplateState.deleteEntityOngoing
);

export const selectCategories = createSelector(
  selectSpaceTemplateState,
  spaceTemplateState => spaceTemplateState.categories
);
